module.exports = __webpack_public_path__ + "static/media/ATB.517bcd90.png";